__turbopack_context__.v({
  "image": "ProjectImage-module__FSJyXq__image",
  "imageContainer": "ProjectImage-module__FSJyXq__imageContainer",
  "placeholder": "ProjectImage-module__FSJyXq__placeholder",
  "shimmer": "ProjectImage-module__FSJyXq__shimmer",
});
